/**
 * Copyright 2025-2026 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const _brand: string = typeof __SDK_BRAND__ !== 'undefined' ? __SDK_BRAND__ : 'vwo';

export const isWingify = _brand === 'wingify';
export const BRAND_DISPLAY_NAME = isWingify ? 'Wingify' : 'VWO';
export const LOG_PREFIX = isWingify ? 'Wingify-React-SDK' : 'VWO-React-SDK';
